export default __webpack_public_path__ + "static/media/waves-opaque.dbc8fd71.svg";